import React, { useState } from "react";
import { Card, Row, Col, Select, Typography, DatePicker } from "antd";
import { FilterOutlined, CalendarOutlined } from "@ant-design/icons";
import Text from "antd/lib/typography/Text";
import moment from "moment";

const { Title } = Typography;
const { Option } = Select;

const datePeriodOptions = [
  {
    label: "All Time",
    value: "all_time",
    startDate: null,
    endDate: null,
  },
  {
    label: "Last 7 Days",
    value: "last_7_days",
    startDate: moment().subtract(7, "days").startOf("day").utcOffset("+05:30"),
    endDate: moment().endOf("day").utcOffset("+05:30"),
  },
  {
    label: "Last 15 Days",
    value: "last_15_days",
    startDate: moment().subtract(15, "days").startOf("day").utcOffset("+05:30"),
    endDate: moment().endOf("day").utcOffset("+05:30"),
  },
  {
    label: "Last Month",
    value: "last_month",
    startDate: moment().subtract(1, "month").startOf("day").utcOffset("+05:30"),
    endDate: moment().endOf("day").utcOffset("+05:30"),
  },
  {
    label: "Last 3 Months",
    value: "last_3_months",
    startDate: moment()
      .subtract(3, "months")
      .startOf("day")
      .utcOffset("+05:30"),
    endDate: moment().endOf("day").utcOffset("+05:30"),
  },
  {
    label: "Custom Date Range",
    value: "custom_date_range",
    startDate: null,
    endDate: null,
  },
];

function LabDashboardFilter({
  commodities,
  selectedDatePeriod,
  setSelectedDatePeriod,
  selectedCommodities,
  setSelectedCommodities,
  dateRange,
  setDateRange,
}) {
  const handleDatePeriodChange = (value) => {
    setSelectedDatePeriod(value);
    // Find the selected option and update dateRange
    const selectedOption = datePeriodOptions?.find(
      (option) => option?.value === value
    );
    if (selectedOption) {
      setDateRange({
        startDate: selectedOption?.startDate
          ? selectedOption?.startDate?.format("YYYY-MM-DDTHH:mm:ssZ")
          : null,
        endDate: selectedOption?.endDate
          ? selectedOption?.endDate?.format("YYYY-MM-DDTHH:mm:ssZ")
          : null,
      });
    }
  };

  return (
    <Card
      style={{
        marginBottom: 24,
        borderRadius: "12px",
        border: "1px solid #e8e8e8",
      }}
      bodyStyle={{
        padding: "25px",
      }}
    >
      <div style={{ marginBottom: "16px" }}>
        <Title
          level={4}
          style={{
            display: "flex",
            alignItems: "center",
            gap: "8px",
          }}
        >
          <FilterOutlined style={{ fontSize: "16px" }} />
          Filters
        </Title>
      </div>

      <Row gutter={[24, 16]}>
        <Col xs={12} sm={12} md={12} lg={12} xl={12}>
          <div>
            <div style={{ marginBottom: "8px" }}>
              <Text
                style={{
                  fontWeight: 600,
                  lineHeight: "24px",
                }}
              >
                Date Range
              </Text>
            </div>
            <Select
              value={selectedDatePeriod}
              onChange={handleDatePeriodChange}
              style={{
                width: "100%",
              }}
              placeholder="All Time"
            >
              {datePeriodOptions?.map((option) => (
                <Option key={option.value} value={option.value}>
                  {option.label}
                </Option>
              ))}
            </Select>
          </div>

          {/* Custom Date Range  */}
          {selectedDatePeriod === "custom_date_range" && (
            <div style={{ display: "flex", gap: "16px", marginTop: "12px" }}>
              <div>
                <div>
                  <Text
                    style={{
                      fontWeight: 600,
                      color: "#666666",
                    }}
                  >
                    Start Date
                  </Text>
                </div>
                <DatePicker
                  value={
                    dateRange?.startDate ? moment(dateRange?.startDate) : null
                  }
                  onChange={(date) =>
                    setDateRange((prev) => ({
                      ...prev,
                      startDate: date
                        ? date
                            .startOf("day")
                            .utcOffset("+05:30")
                            .format("YYYY-MM-DDTHH:mm:ssZ")
                        : null,
                    }))
                  }
                  placeholder="Start Date"
                  suffixIcon={<CalendarOutlined style={{ color: "#bfbfbf" }} />}
                  format="DD/MM/YYYY"
                />
              </div>

              <div>
                <div>
                  <Text
                    style={{
                      fontWeight: 600,
                      color: "#666666",
                    }}
                  >
                    End Date
                  </Text>
                </div>
                <DatePicker
                  value={dateRange?.endDate ? moment(dateRange?.endDate) : null}
                  onChange={(date) =>
                    setDateRange((prev) => ({
                      ...prev,
                      endDate: date
                        ? date
                            .endOf("day")
                            .utcOffset("+05:30")
                            .format("YYYY-MM-DDTHH:mm:ssZ")
                        : null,
                    }))
                  }
                  style={{}}
                  placeholder="End Date"
                  suffixIcon={<CalendarOutlined style={{ color: "#bfbfbf" }} />}
                  format="DD/MM/YYYY"
                  disabledDate={(current) => {
                    return (
                      dateRange?.startDate &&
                      current &&
                      current < moment(dateRange?.startDate).endOf("day")
                    );
                  }}
                />
              </div>
            </div>
          )}
        </Col>
        {/* Commodity filter */}
        <Col xs={12} sm={12} md={12} lg={12} xl={12}>
          <div>
            <div style={{ marginBottom: "8px" }}>
              <span
                style={{
                  fontWeight: 600,
                  lineHeight: "24px",
                }}
              >
                Commodity
              </span>
            </div>
            <Select
              mode="multiple"
              value={selectedCommodities}
              onChange={setSelectedCommodities}
              style={{
                width: "100%",
              }}
              placeholder="Select commodities..."
              showSearch
              filterOption={(input, option) =>
                option.children.toLowerCase().includes(input.toLowerCase())
              }
              maxTagCount="responsive"
            >
              {commodities?.map((option) => (
                <Option key={option._id} value={option._id}>
                  {option.name}
                </Option>
              ))}
            </Select>
          </div>
        </Col>
      </Row>
    </Card>
  );
}

export default LabDashboardFilter;
